import React, { useState, useEffect, useMemo, useContext } from "react";
import Box from "@mui/system/Box";
import Typography from "@mui/material/Typography";
import AppBar from "@mui/material/AppBar";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import "./styles/Verification.css";
import { HalfBoxClinical } from "../components/scripts/HalfBoxClinical";
import { ApiCall } from "../utility/ApiCalls";
import Loader from "react-loader-spinner";
import { GuidelinesProvider } from "./GuideLinesProvider";
import { useLocation } from "react-router-dom";
import Api_Call from "../ApiCall";
import menus from "../user-config.json";
import UserContext from "../components/Common/UserContext";
import TextSnippetIcon from "@mui/icons-material/TextSnippet";
import RuleIcon from "@mui/icons-material/Rule";

function ClinicalReview() {
  const [isLoading, setLoading] = useState(true);
  const [ocrData, setOCRData] = useState([]);
  const [displayReady, setDisplayReady] = useState(false);
  const [displayReadyActiveTask, setDisplayReadyActiveTask] = useState(false);
  const [displayReadyFax, setDisplayReadyFax] = useState(false);
  const [activeTaskData, setActiveTaskData] = useState([]);
  const [ocrDataCPT, setCPTData] = useState([]);
  const [ocrDataDX, setDXData] = useState([]);
  const [ocrDataProvider, setProviderData] = useState([]);
  const [umreviewType, setUMReviewType] = useState([]);
  const [admissionSource, setAdmissionSource] = useState([]);
  const [admissionType, setAdmissionType] = useState([]);
  const [requestProfile, setRequestProfile] = useState([]);
  const [selectedUMreviewType, setUMReviewTypeSelected] = useState("");
  const [selectedAdmissionSource, setAdmissionSourceSelected] = useState("");
  const [selectedAdmissionType, setAdmissionTypeSelected] = useState("");
  const [selectedRequestProfile, setSelectedRequestProfile] = useState("");
  const [selectedUMReviewTypeData, setSelectedUMReviewTypeData] = useState("");
  const [requestProfileData, setRequestProfileData] = useState("");
  const [coords, setCoords] = useState("");
  const [taskStatus, setTaskStatus] = useState();
  const [completedTime, setCompletedTime] = useState();
  const [error, setError] = useState(false);
  const { userRole } = useContext(UserContext);
  const [filename, setfilename] = useState();
  const [fax, setFax] = useState();
  const [guidelines, setGuidelines] = useState({
    LCD: "",
    NCD: "",
    LCA: "",
    MCG: "",
    guideline_summary: "",
    clinical_summary: "",
  });
  //const [tabledata, setTableData] = useState({"CPTCode_CR":"", "DescriptionText_CR":"", "Unit_NR":"", "AnticipatedStartDate_DT":"", "AnticipatedEndtDate_DT":"" });
  const [clinicaldoc, setClinicalDoc] = useState();
  const [statusMessgae, setStatusMessage] = useState("");
  const [authId, setAuthId] = useState();

  const [criteriaMet, setCriteriaMet] = useState("");
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const activeTile = searchParams.get("activeTile");

  // API CALL FUNCTION DECLARATION  ============================================================

  async function getvalidatedtask(e) {
    try {
      const api = new Api_Call();
      const data = await api.getData(
        `VALIDATIONS/GET-DATA?taskID=${sessionStorage.getItem(
          "ActiveTaskID"
        )}&clinical_data=${menus[userRole.toLowerCase()]["clinical"]}`
      );
      if (data.statusCode != 200) {
        throw new Error("Error Fetching Data");
      }
      // setTaskStatus(data.body.Status);
      // setCompletedTime(data.body.Status);

      setTaskStatus(data.body.Status);
      setCompletedTime(data.body.Status);
      setStatusMessage(data.body["Status_Message"]);
      setAuthId(data.body["Auth_ID"]);
      setCriteriaMet(data.body["Criteria"]);
      console.log(
        "setting state ===================================================== "
      );
      console.log("response from getOCRData ", data.body);
      getClinical(data.body.ClinicalInfo);
    } catch (error) {
      console.error(error.message);
      setError(error);
    }

    // console.log('Inside getValidatedTask API call ');
    // const ret = await ApiCall(
    //   {
    //     taskID: sessionStorage.getItem("ActiveTaskID"),
    //     // taskID: "9",
    //     clinical_data: "1",
    //   },
    //   "vcare-ui",
    //   "agent_getvalidatedtask"
    // );
    // setTaskStatus(ret.body.Status);
    // setCompletedTime(ret.body.Status);
    // setStatusMessage(ret.body['Status_Message'])
    // console.log('setting state ===================================================== ');
    // console.log('response from getOCRData ', ret.body);
    // getClinical(ret.body.ClinicalInfo);
  }

  function getClinical(clinical_info) {
    console.log(clinical_info[0]);
    if (Object.keys(clinical_info[0]).length === 0) {
      console.log("dict is empty ");
      setGuidelines({
        LCD: "",
        NCD: "",
        LCA: "",
        MCG: "",
        guideline_summary: "",
        clinical_summary: "",
      });
    } else {
      // console.log('atob LCD');
      const byteCharactersLCD = atob(clinical_info[0]["LCD"]);
      // console.log('atob MCG');
      const byteCharactersMCG = atob(clinical_info[0]["MCG"]);
      // console.log('atob NCD');
      const byteCharactersNCD = atob(clinical_info[0]["NCD"]);
      // console.log('atob LCA');
      const byteCharactersLCA = atob(clinical_info[0]["LCA"]);
      // console.log('atob Summary');
      // const guidelineSummary = atob(clinical_info[0]["Summary"]);
      const guidelineSummary = clinical_info[0]["Summary"];
      // console.log('atob clinicals');
      // const clinicalSummary = atob(clinical_info[0]["Clinical Summary"]);
      const clinicalSummary = clinical_info[0]["Clinical Summary"];
      setGuidelines({
        LCD: byteCharactersLCD,
        NCD: byteCharactersNCD,
        LCA: byteCharactersLCA,
        MCG: byteCharactersMCG,
        guideline_summary: guidelineSummary,
        clinical_summary: clinicalSummary,
      });
    }
  }

  // const memoizedFilteredGuidelines=useMemo(()=>guidelines.guideline_summary,[guidelines.guideline_summary])

  // useEffect(()=>{
  //   console.log(guidelines.guideline_summary)

  //   if(guidelines.guideline_summary)
  //   {
  //      console.log(guidelines.guideline_summary)
  //      setFilteredGuidelines(guidelines.guideline_summary)
  //   }
  // },[memoizedFilteredGuidelines])

  async function getOCRDatafromAPI() {
    try {
      const api = new Api_Call();
      const data = await api.getData(
        `VALIDATIONS/GET-DATA?taskID=${sessionStorage.getItem(
          "ActiveTaskID"
        )}&clinical_data=${menus[userRole.toLowerCase()]["clinical"]}`
      );

      if (data.statusCode !== 200) {
        throw new Error("Error Fetching Data");
      }
      const response = data.body;
      console.log(response);

      if (response.CPTCodes != null) {
        setCPTData(response.CPTCodes.value);
      }
      if (response.DiagnosisCodes != null) {
        setDXData(response.DiagnosisCodes.value);
      }
      if (response.Providers != null) {
        setProviderData(response.Providers);
      }
      if (response.ClinicalInfo) {
        getClinical(response.ClinicalInfo);
      }
      setOCRData(response);

      setSelectedUMReviewTypeData(response.UMReviewType);
      setRequestProfileData(response.RequestProfile);
      getClinical(response.ClinicalInfo);
      return true;
    } catch (error) {
      console.error(error.message);
      setError(error);
    }

    // const retAssigned = await ApiCall(
    //   {
    //     taskID: sessionStorage.getItem("ActiveTaskID"),
    //     // taskID: "9",
    //     clinical_data: "1",
    //   },
    //   "vcare-ui",
    //   "agent_getvalidatedtask"
    //   // "agent_gettaskdetails"
    // );

    // const response = retAssigned.body;
    // console.log("response from getOCRData ", retAssigned.body);

    // if (response.CPTCodes != null) {
    //   setCPTData(response.CPTCodes);
    // }
    // if (response.DiagnosisCodes != null) {
    //   setDXData(response.DiagnosisCodes);
    // }
    // if (response.Providers != null) {
    //   setProviderData(response.Providers);
    // }
    // if (response.ClinicalInfo) {
    //   getClinical(response.ClinicalInfo);
    // }
    // if (response) {
    //   setOCRData(response);
    // }

    // setSelectedUMReviewTypeData(response.UMReviewType);
    // setRequestProfileData(response.RequestProfile);
    // // getClinical(response.ClinicalInfo);
    // return true;
  }

  async function getActiveTaskfromAPI() {
    // const retActive = await ApiCall(
    //   {
    //     requestType: "Agent",
    //     filterType: "",
    //     status: "T02",
    //     agentID: sessionStorage.getItem("UserID"), //GET ID from SESSION
    //     supervisorID: "",
    //   },
    //   "vcare-ui",
    //   "tasklist"
    // );
    // const response = retActive.body;
    // setActiveTaskData(response);
    // if (retActive.statusCode == "200") {
    setDisplayReadyActiveTask(true);
    // }
  }

  async function getUMReviewTypefromAPI() {
    // const retActive = await ApiCall("", 'vcare-ui', 'vcare_umreviewtype');

    const api = new Api_Call();
    const data = await api.getData(
      "MASTERS/MANAGEMENT?master_type=umreviewtype"
    );
    const response = data.body;
    setUMReviewType(response);

    const api2 = new Api_Call();
    const data2 = await api2.getData(
      "MASTERS/MANAGEMENT?master_type=admissionsource"
    );
    setAdmissionSource(data2.body);

    const api3 = new Api_Call();
    const data3 = await api3.getData(
      "MASTERS/MANAGEMENT?master_type=admissiontype"
    );
    setAdmissionType(data3.body);

    const api4 = new Api_Call();
    const data4 = await api4.getData(
      "MASTERS/MANAGEMENT?master_type=authorizationprofile"
    );
    setRequestProfile(data4.body);

    // const retActive = await ApiCall("", "vcare-ui", "vcare_getumreviewtype");
    // const response = retActive.body;
    // setUMReviewType(response);

    // const retAdmissionSource = await ApiCall(
    //   "",
    //   "vcare-ui",
    //   "vcare_getadmissionsource"
    // );
    // const response2 = retAdmissionSource.body;
    // setAdmissionSource(response2);

    // const retAdmissionType = await ApiCall(
    //   "",
    //   "vcare-ui",
    //   "vcare_getadmissiontype"
    // );
    // const response3 = retAdmissionType.body;
    // setAdmissionType(response3);

    // const getRequestProfile = await ApiCall(
    //   "",
    //   "vcare-ui",
    //   "vcare_requestprofile"
    // );
    // const response4 = getRequestProfile.body;
    // setRequestProfile(response4);
  }

  async function getFaxfromAPI() {
    try {
      const api = new Api_Call();
      const data = await api.getData(
        `FAX/GET?taskID=${sessionStorage.getItem("ActiveTaskID")}`
      );
      if (data.statusCode != 200) {
        throw new Error("Error Fetching Data");
      }
      console.log(data);
      setfilename(data.body.Clinical_PDF_URL);
      setFax(data);
      if (data != undefined) {
        setDisplayReadyFax(true);
      }
    } catch (error) {
      console.error(error.message);
      setError(error);
    }

    // const response = await ApiCall(
    //   {
    //     taskID: sessionStorage.getItem("ActiveTaskID"),
    //     //taskID: "9",
    //   },
    //   "vcare-ui",
    //   //"agent_gettaskdetails/getfax"
    //   "agent_gettaskdetails/zone2_getfax" // QA instance
    //   //"agent_gettaskdetails/demo_getfax" // Demo instance
    // );

    // setFax(response);
    // console.log("---------->", response);
    // if (response != undefined) {
    //   setDisplayReadyFax(true);
    // }
  }

  async function getClinicalDocfromAPI() {
    try {
      const api = new Api_Call();
      const data = await api.getData(
        `FAX/GET?taskID=${sessionStorage.getItem("ActiveTaskID")}`
      );
      if (data.statusCode != 200) {
        throw new Error("Error Fetching Data");
      }
      if (data && data.body) {
        console.log(data);
        setClinicalDoc(data);
      }
      if (data != undefined) {
        setDisplayReadyFax(true);
      }
    } catch (error) {
      console.error(error.message);
      setError(error);
    }

    // const response = await ApiCall(
    //   {
    //     taskID: sessionStorage.getItem("ActiveTaskID"),
    //     //taskID: "9",
    //   },
    //   "vcare-ui",
    //   //"agent_gettaskdetails/getfax"
    //   "agent_gettaskdetails/zone2_getfax" // QA instance
    //   //"agent_gettaskdetails/demo_getfax" // Demo instance..
    // );
    // if (response && response.body) {
    //   console.log(response);
    //   setClinicalDoc(response);
    // }
    // if (response != undefined) {
    //setDisplayReadyFax(true);
    // }
  }

  const b64toBlob = (b64Data, contentType = "", sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  };

  const getHeightAndWidthOfElement = (elementId) => {
    let element = document.getElementById(elementId);
    if (!element) {
      return {
        width: 0,
        height: 0,
      };
    }
    return {
      width: element.getBoundingClientRect().width,
      height: element.getBoundingClientRect().height,
    };
  };

  function LoadContent() {
    if (ocrData.length != 0) {
      setDisplayReady(true);
    }
  }

  //   function createTableData() {
  //     console.log('task data ', ocrDataCPT);
  //     //const cpt_data = ocrDataCPT.cptData;
  //     //console.log('cpt data ', cpt_data);
  //     setTableData(ocrDataCPT);
  //     console.log('state data ',tabledata);
  //   }

  useEffect(() => {
    getvalidatedtask();
    getOCRDatafromAPI();
    getActiveTaskfromAPI();
    getUMReviewTypefromAPI();
    getFaxfromAPI();
    getClinicalDocfromAPI();
  }, []);

  useEffect(() => {
    LoadContent();
  }, [ocrData]);

  useEffect(() => {
    if (displayReady && displayReadyActiveTask && displayReadyFax) {
      setLoading(false);
    }
  }, [displayReady, displayReadyActiveTask, displayReadyFax]);

  if (isLoading) {
    return (
      <div>
        {/* <div className="content-container">
          <div className="div-loading">
            <Loader type="Puff" color="#00BFFF" height={100} width={100} />
          </div>
        </div> */}
        <Box className="loader-wrapper">
          <div className="loader"></div>
        </Box>
      </div>
    );
  } else {
    return (
      <>
        <Box className="primary-title-new">
          <img src="img/heading-bg.png" />
          <Typography variant="h1">
            Utilization Management - <span> Clinical Review </span>
          </Typography>
        </Box>
        <div className="verification-content-main">
          <div className="content-container halfbox-container">
            {/* <div style={{ position: "absolute", left: "0", top: "1%" }}>
              <p>
                <b>Remark</b>: {statusMessgae}
              </p>
              <p>
                <b>Case Status</b>:{" "}
                <span style={{ textTransform: "capitalize" }}>
                  {activeTile}
                </span>
              </p>
            </div> */}
            <div
              className="task-details"
              style={{
                position: "absolute",
                left: 0,
                textTransform: "capitalize",
              }}
            >
              <div className="timer">
                <label>
                  <TextSnippetIcon />
                  Remark: {statusMessgae}
                </label>
              </div>

              <div className="timer">
                <label>
                  {" "}
                  <RuleIcon /> Case Status: {activeTile}
                </label>
              </div>
            </div>
            <GuidelinesProvider>
              <HalfBoxClinical
                //  text={filteredGuidelines}
                //  setText={setFilteredGuidelines}

                fax={fax}
                clicaldoc={clinicaldoc}
                coords={coords}
                ocrData={ocrData}
                taskData={activeTaskData}
                setOCRData={setOCRData}
                selectedUMReviewTypeData={selectedUMReviewTypeData}
                requestProfileData={requestProfileData}
                dxData={ocrDataDX}
                setDXData={setDXData}
                cptData={ocrDataCPT}
                setCPTData={setCPTData}
                providerData={ocrDataProvider}
                setProviderData={setProviderData}
                umReviewTypeCB={umreviewType}
                admissionSourceCB={admissionSource}
                requestProfileCB={requestProfile}
                admissionTypeCB={admissionType}
                selectedUMreviewType={selectedUMreviewType}
                setUMReviewTypeSelected={setUMReviewTypeSelected}
                selectedAdmissionSource={selectedAdmissionSource}
                setAdmissionSourceSelected={setAdmissionSourceSelected}
                selectedAdmissionType={selectedAdmissionType}
                setAdmissionTypeSelected={setAdmissionTypeSelected}
                selectedRequestProfile={selectedRequestProfile}
                setSelectedRequestProfile={setSelectedRequestProfile}
                loading={isLoading}
                setLoading={setLoading}
                taskStatus={taskStatus}
                completedTime={completedTime}
                getOCRDatafromAPI={getOCRDatafromAPI}
                guidelines={guidelines}
                authId={authId}
                criteriaMet={criteriaMet}
              ></HalfBoxClinical>
            </GuidelinesProvider>
          </div>
        </div>
      </>
    );
  }
}

export default ClinicalReview;
